/* Shared invoice helper — builds a plain-text Blob and triggers download.
 * Used by both confirmation-page and user-portal order detail page. */

import { inr } from "@/data/data";

export function buildInvoiceText(order) {
  const lines = [];
  lines.push("NETHRASAP — INVOICE");
  lines.push("====================");
  lines.push(`Order ${order.number}`);
  lines.push(`Placed: ${new Date(order.placed_at).toLocaleString("en-IN")}`);
  lines.push(`Status: ${order.status}`);
  lines.push("");
  lines.push("Ship to:");
  lines.push(`  ${order.address.full_name}`);
  lines.push(`  ${order.address.line1}${order.address.line2 ? ", " + order.address.line2 : ""}`);
  lines.push(`  ${order.address.city} ${order.address.pin}, ${order.address.state}`);
  lines.push(`  ${order.address.phone}`);
  lines.push("");
  lines.push("Items:");
  order.items.forEach((it) => {
    lines.push(`  - ${it.product_name}  ×${it.qty}  ${inr(it.line_total)}`);
  });
  lines.push("");
  lines.push(`Subtotal:  ${inr(order.subtotal)}`);
  if (order.discount) lines.push(`Discount:  -${inr(order.discount)}`);
  lines.push(`GST (5%):  ${inr(order.gst_amount)}`);
  lines.push(`Shipping:  ${order.shipping === 0 ? "FREE" : inr(order.shipping)}`);
  lines.push(`TOTAL:     ${inr(order.total)}`);
  lines.push("");
  lines.push(`Payment: ${(order.payment_method || "").toUpperCase()} · ${order.payment_status || ""}`);
  lines.push(`Delivery: ${order.delivery_method}`);
  return lines.join("\n");
}

export function downloadInvoice(order) {
  if (typeof window === "undefined") return;
  const text = buildInvoiceText(order);
  const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `nethrasap-invoice-${order.number}.txt`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
